<template>
    <div>
        <el-upload
                class="upload-banner"
                action=""
                :drag="drag"
                :list-type="listType"
                :auto-upload="true"
                :on-change="handleCrop"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList"
                :limit="1"
                ref="upload"
                :show-file-list="true">
            <slot name="content">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </slot>
        </el-upload>
        <!-- 剪裁组件弹窗 -->
        <cropperImage
                :dialogVisible="showCropper"
                :cropper-option="cropperOption"
                :file-size="fileSize"
                :cropper-style="cropperStyle"
                @close="showCropper=false"
                @uploadCropper="uploadImg"
        />
    </div>
</template>

<script>
    import cropperImage from './cropperImage';

    export default {
        name: 'Cropper',
        props: {
            value: String,
            data: Object,
            showFileList: {type: Boolean, default: true},
            listType: {type: String, default: 'picture'},
            drag: {type: Boolean, default: true},
        },
        components: {
            cropperImage
        },
        computed: {
            fileList() {
                return this.value
                    ? this.value.split(',').map(item => {
                        return {
                            name: item,
                            url: item
                        };
                    }) : [];
            }
        },
        data() {
            return {
                cropperData: {},
                showCropper: false, // 显示裁剪弹窗
                canCropper: false,
                fileSize: 10, // 限制文件上传大小
                cropperOption: {
                    img: '',
                    autoCropWidth: 375,
                    autoCropHeight: 176
                },
                cropperStyle: {
                    width: '390px',
                    height: '290px'
                }
            }
        },
        methods: {
            handleCrop(file) {
                // 点击弹出剪裁框
                this.$nextTick(() => {
                    if (this.canCropper) {
                        this.cropperOption.img = window.URL.createObjectURL(file.raw)
                        this.showCropper = this.canCropper
                    }
                })
            },
            beforeAvatarUpload(file) {
                // 上传前校验
                const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
                const isLt2M = file.size / 1024 / 1024 < 10
                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 10 MB!')
                }
                // 校验通过后显示裁剪框
                this.canCropper = isJPG && isLt2M
                return false
            },
            uploadImg(file, data) {
                this.cropperData.iconUrl = data
                this.showCropper = false
                this.$axios.post({
                    url: '/admin/common/upload',
                    dataType: 'file',
                    data: file
                }).then((data) => {
                    this.handleSuccess(data);
                    this.showCropper = false
                }).catch(() => {
                    this.handleRemove();
                    this.$message({message: '上传失败', type: 'error'});
                });
            },
            handleSuccess(file) {
                if (file.code === 0) {
                    this.$emit('change', file.data);
                    this.$emit('input', file.data);
                    this.$parent.$emit('el.form.change', file.data);
                } else {
                    this.$message.error(file.msg);
                    this.handleRemove();
                }
            },
            handleRemove() {
                this.$refs['upload'].clearFiles();
                this.$emit('change', '');
                this.$emit('input', '');
                this.$parent.$emit('el.form.change', '');
            }
        }
    }
</script>

<style lang="less" scoped>
</style>